module.exports = __webpack_public_path__ + "img/loginBG_old.b072a0a6.png";